import { Header, Progress } from "semantic-ui-react";
const UploadProgress = (props) => {
  const {
    isUploadingTrailer,
    isUploadingLogo,
    isUploadingPoster,
    trailerUploadProgress,
    posterUploadProgress,
    logoUploadProgress,
  } = props;
  return (
    <div
      style={{
        position: "absolute",
        right: "10px",
        top: "10px",
        width: "250px",
        height: "auto",
        backgroundColor: "#F1F1F1",
        padding: "10px",
        zIndex: 10,
        borderRadius: "10px",
      }}
    >
      {isUploadingTrailer && (
        <div>
          <Header>Uploading Trailer</Header>
          <Progress
            percent={Math.trunc(trailerUploadProgress * 100)}
            progress={Math.trunc(trailerUploadProgress * 100)}
            indicating
          />
        </div>
      )}
      {isUploadingLogo && (
        <div>
          <Header>Uploading Logo</Header>
          <Progress
            percent={Math.trunc(logoUploadProgress * 100)}
            progress={Math.trunc(logoUploadProgress * 100)}
            indicating
          />
        </div>
      )}
      {isUploadingPoster && (
        <div>
          <Header>Uploading Poster</Header>
          <Progress
            percent={Math.trunc(posterUploadProgress * 100)}
            progress={Math.trunc(posterUploadProgress * 100)}
            indicating
          />
        </div>
      )}
    </div>
  );
};
export default UploadProgress;
